import { NavLink, Outlet, Navigate } from "react-router-dom";
import { TopBar } from "@/components/Shell";
import { useAuth } from "@/context/AuthContext";
import { ADMIN } from "@/constants/testIds";
import {
  LayoutDashboard, Users, Building2, Palette, Shield,
} from "lucide-react";

export default function AdminLayout() {
  const { user, checked } = useAuth();
  if (!checked)
    return (
      <div className="min-h-screen grid place-items-center font-mono text-xs uppercase tracking-widest">
        Checking session…
      </div>
    );
  if (!user || user === false) return <Navigate to="/admin/login" replace />;

  const isSuper = user.role === "super_admin";

  return (
    <div className="min-h-screen">
      <TopBar mode="admin" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-8">
        <nav className="flex gap-2 mb-8 flex-wrap">
          <NavLink
            end
            to="/admin"
            data-testid={ADMIN.navDashboard}
            className={({ isActive }) =>
              `btn-brut ${isActive ? "btn-flame" : "btn-ghost"}`
            }
          >
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>
          <NavLink
            to="/admin/candidates"
            data-testid={ADMIN.navCandidates}
            className={({ isActive }) =>
              `btn-brut ${isActive ? "btn-flame" : "btn-ghost"}`
            }
          >
            <Users size={16} /> Candidates
          </NavLink>
          {isSuper && (
            <>
              <NavLink
                to="/admin/intakes"
                data-testid={ADMIN.navIntakes}
                className={({ isActive }) =>
                  `btn-brut ${isActive ? "btn-flame" : "btn-ghost"}`
                }
              >
                <Building2 size={16} /> Intakes
              </NavLink>
              <NavLink
                to="/admin/users"
                data-testid="admin-nav-users"
                className={({ isActive }) =>
                  `btn-brut ${isActive ? "btn-flame" : "btn-ghost"}`
                }
              >
                <Shield size={16} /> Users
              </NavLink>
              <NavLink
                to="/admin/branding"
                data-testid="admin-nav-branding"
                className={({ isActive }) =>
                  `btn-brut ${isActive ? "btn-flame" : "btn-ghost"}`
                }
              >
                <Palette size={16} /> Branding
              </NavLink>
            </>
          )}
        </nav>
        {user.role === "company_admin" && user.intake_client_name && (
          <div className="brut-card p-3 mb-6 flex items-center gap-2 text-sm font-mono">
            <Building2 size={14} />
            <span className="uppercase tracking-widest text-[11px] text-black/60">
              Scoped view · you can only see
            </span>
            <b>{user.intake_client_name}</b>
          </div>
        )}
        <Outlet />
      </div>
    </div>
  );
}
